import ValueRange from '../../../models/ValueRange.js';
import template from './ko-field-view-date-range.html';

class DateRangeComponentVM
{
	constructor(params)
	{
		this.params = params;
		this.value = ko_helper.safe_observable(params.value);
		this.extra_classes = ko_helper.safe_observableArray(params.extra_classes || []);

		this.value_range = new ValueRange(this.value, {
			serialize_function: (val) =>
			{
				if (!val) return '';
				let m = new moment(val, 'YYYY-MM-DD');
				return m.isValid ? m.toDate().toLocaleDateString() : '';
			},
			deserialize_function: (val) =>
			{
				if (!val) return '';
				let m = new moment(val);
				return m.isValid ? m.format('YYYY-MM-DD') : '';
			}
		});
	}
}


export default {
	name: 'ko-field-view-date-range',
	viewModel: DateRangeComponentVM,
	module_type: 'ko',
	template: template
};
